import { componentQrl, inlinedQrl, useId, useSignal, useContextProvider, _jsxS, _jsxC, Slot } from "@builder.io/qwik";
import { modalContextId } from "./modal-context.qwik.mjs";
const HModalRoot = /* @__PURE__ */ componentQrl(/* @__PURE__ */ inlinedQrl((props) => {
  const localId = useId();
  const { "bind:show": givenShowSig, closeOnBackdropClick, onShow$, onClose$, alert } = props;
  const defaultShowSig = useSignal(false);
  const showSig = givenShowSig ?? defaultShowSig;
  const context = {
    localId,
    showSig,
    closeOnBackdropClick,
    onShow$,
    onClose$,
    alert
  };
  useContextProvider(modalContextId, context);
  return /* @__PURE__ */ _jsxS("div", {
    ...props,
    children: /* @__PURE__ */ _jsxC(Slot, null, 3, "1n_0")
  }, null, 0, "1n_1");
}, "HModalRoot_component_3nHfDoo6zok"));
export {
  HModalRoot
};
